const TIMEZONE = 'America/Los_Angeles';
// const TIMEZONE = 'America/New_York';
const DATE_FORMAT = 'M-D-YYYY';
const URLParams = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
const UTILS = {
  FormatDigits(n) {
    let num_digits = n.toString().split('').length;
    return ("0" + n).slice(0 - ((num_digits < 2) ? 2 : num_digits));
  },
  
  GetCountdown(date_time) {
    let countdown_date = moment().tz(TIMEZONE);
    let date = date_time.split(':')[0];
    let time = date_time.split(':')[1];

    let month = parseInt(date.split('-')[0]);
    countdown_date.month(month - 1);
    let day = parseInt(date.split('-')[1]);
    countdown_date.date(day);
    let year = date.split('-')[2];
    countdown_date.year(year)

    let hour = time.split('-')[0] || 0;
    countdown_date.hour(hour);
    let min = time.split('-')[1] || 0;
    countdown_date.minute(min);
    let sec = 0;
    countdown_date.second(sec);

    let now = moment().tz(TIMEZONE);
    let duration = moment.duration(countdown_date.diff(now));
    let days = Math.floor(duration.asDays());
    let hours = duration.hours();
    let minutes = duration.minutes();
    let seconds = duration.seconds();

    // console.log(date, now, date.diff(now), duration, days, hours, minutes)
    days = UTILS.FormatDigits(days);
    hours = UTILS.FormatDigits(hours);
    minutes = UTILS.FormatDigits(minutes);
    seconds = UTILS.FormatDigits(seconds);

    if (countdown_date.isBefore(now)) {
      return '<span>00:00:00:00</span>';
    }

    let countdownText = `<span data-value="${ days }">${ days }:</span><span data-value="${ hours }">${ hours }:</span><span data-value="${ minutes }">${ minutes }:</span><span data-value="${ seconds }">${ seconds }</span>`;
    return countdownText;
  }
};
(() => {
  document.addEventListener('audio-control-init', (e) => {
    var $section = e.target.closest('.video-parent-section');
    if (!$section) return;

    $section.addEventListener('click', function(e) {
      var video_type = $section.querySelector('.video-div').dataset.type;
      var player_id = $section.querySelector('.video-div').getAttribute('id');
      
      if (video_type == 'youtube') {
        var player = YT.get(player_id);
        //console.log(player_id, player);
        player[player.isMuted() ? 'unMute' : 'mute']();
      }
      
      else if (video_type == 'vimeo') {
        var player = new Vimeo.Player(document.querySelector('.video-div iframe'));
        //console.log(player);
        player.getMuted().then(function(muted) {
          player.setVolume(muted ? 1 : 0);
        });
      }

      else if (video_type == 'mp4') {
        var $video = $section.querySelector('video');
        $video.muted = !$video.muted;
      }
    });
  });

  document.addEventListener('alpine:init', () => {
    Alpine.data('CollectionTiles', () => ({
      $section: null,
      $tiles: null,
      init() {
        let am = this;
        document.addEventListener('init-CollectionTiles', (e) => {
          if (am.$section) return;
          am.$section = e.target;

          am.$tiles = am.$section.querySelectorAll('.grid-tile');
          am.MoveTilesToCollection();
        });
      },
      MoveTilesToCollection() {
        let am = this;
        let $collection = document.querySelector('.collection-grid');
        if (!$collection) return;

        console.log(am.$tiles);

        am.$tiles.forEach(($tile) => {
          $collection.insertAdjacentElement('beforeend', $tile);
        });
      }
    }));

    Alpine.data('CountdownTimer', () => ({
      $section: null,
      countdownText: '',
      countdown_t: null,
      init() {
        let am = this;
        document.addEventListener('init-CountdownTimer', (e) => {
          if (am.$section) return;
          am.$section = e.target;
          am.UpdateCountdown();
        });
      },
      UpdateCountdown() {
        let am = this;
        if (!am.$section) return;
        let countdown_date = am.$section.dataset.countdown;
        clearInterval(am.countdown_t);
        am.countdown_t = setInterval(() => {
          am.countdownText = UTILS.GetCountdown(countdown_date);
        }, 1000); // Update every second
      }
    }));

    const MAX_QTY = 10;
    Alpine.data('PDPQuantity', () => ({
      variants: [],
      max: MAX_QTY,
      qty: 1,
      selected_variant: null,
      init() {
        this.variants = JSON.parse(this.$el.dataset.variants);
        this.$el.removeAttribute('data-variants');
        this.UpdateSelectedVariant();
        this.InitWatchers();
      },
      InitWatchers() {
        let am = this;
        am.$el.closest('.product-section').addEventListener('variantChange', (e) => {
          // console.log(e);
          am.$el.dataset.current_variant_id = e.detail.variant.id;
          am.UpdateSelectedVariant();
        });

        am.$el.querySelector('input').addEventListener('input', (e) => {
          // console.log(e);
          let qty = parseInt(e.target.value);
          am.qty = qty > MAX_QTY ? MAX_QTY : qty;
        });
        am.$el.addEventListener('click', (e) => {
          // console.log(e);
          let qty = parseInt(this.$el.querySelector('input').value);
          am.qty = qty > MAX_QTY ? MAX_QTY : qty;
        });
      },
      UpdateSelectedVariant() {
        this.selected_variant = this.variants.find(v => v.id == this.$el.dataset.current_variant_id);
        let variant_max_qty = this.selected_variant.inventory_quantity;
        this.max = variant_max_qty > MAX_QTY ? MAX_QTY : variant_max_qty;
      }
    }));

    Alpine.data('CartItemQuantity', (qty) => ({
      qty: qty,
      max: MAX_QTY,
      e_CheckMaxQty(e) {
        let qty = parseInt(e.target.value);
        this.qty = qty > this.max ? this.max : qty;
        e.target.value = this.qty;
      }
    }));
  });

  RedirectInvalidPage = () => {
    window.location.href = '/pages/invalid-link';
  }
  ValidateBlueBite = async () => {
    if (window.location.pathname.indexOf('verified') == -1) return;

    let bb_event = URLParams.bb_event;
    if (!bb_event) {
      RedirectInvalidPage();
    }

    let res = await fetch(`https://api.bluebite.com/v3/events/${bb_event}?format=json`).then(res => res.json());
    let dummy_RES_json = {
      verified: {"object":{"uuid":"4be6d2f6-bbeb-464d-b0cd-fa421a15b06a","data":{"tid":"E280B1142000780111D6AA7B","uid":"4BZ4ARHWqns","label_id":"225339","uid_decoded":"E016780111D6AA7B","nfc_description":"Circus_Rolling_Label_RPAC_EM","bb_sequential_id":"BR250124-225339"},"variables":{}},"interaction":{"touchpoint":{"slug":"nrer","technology":"nfc","identifiers":{"uid":"4BZ4ARHWqns"},"url":{"href":"https://bb.io/nrer/?id=4BZ4ARHWqns&token={token}","searchParams":{"id":"4BZ4ARHWqns","token":"{token}"}},"verification":{"supported":true,"result":true},"tamper":{"supported":false,"result":null}},"timestamp":"2025-03-06T14:10:42.564586Z"},"device":{"id":"FPYYBK3STNulhLx1f6BGkSphMHruTuIxsX7LB9sf_aI","ip_address":"96.232.199.70","desktop":"\"macOS\"","browser":"Google Chrome","manufacturer":"Apple","os_name":"\"macOS\"","type":"Mac","carrier":"Verizon Fios","user_agent":"PostmanRuntime/7.43.0"},"location":{"country":{"iso_code":"US","name":"United States"},"subdivision_1":{"iso_code":"NY","name":"New York"},"subdivision_2":{"iso_code":"","name":""},"city":{"geoname_id":"5133273","name":"Queens"},"continent":{"code":"NA","name":"North America"},"latitude":40.726,"longitude":-73.848,"postal_code":"11375","timezone":"America/New_York"},"project":{"id":3868,"name":"🛜 NFC Shipment: 1/24/2025 (200,000ct)","data":{}}},
      unverified: {"object":{"uuid":"4be6d2f6-bbeb-464d-b0cd-fa421a15b06a","data":{"tid":"E280B1142000780111D6AA7B","uid":"4BZ4ARHWqns","label_id":"225339","uid_decoded":"E016780111D6AA7B","nfc_description":"Circus_Rolling_Label_RPAC_EM","bb_sequential_id":"BR250124-225339"},"variables":{}},"interaction":{"touchpoint":{"slug":"nrer","technology":"nfc","identifiers":{"uid":"4BZ4ARHWqns"},"url":{"href":"https://bb.io/nrer/?id=4BZ4ARHWqns&token={token}","searchParams":{"id":"4BZ4ARHWqns","token":"{token}"}},"verification":{"supported":true,"result":false},"tamper":{"supported":false,"result":null}},"timestamp":"2025-03-06T14:12:21.520889Z"},"device":{"id":"gbcAznxIwv38OJ7PomPjsSEgoAl8FMHtL-Aj93bzjVc","ip_address":"96.232.199.70","desktop":"\"macOS\"","browser":"Google Chrome","manufacturer":"Apple","os_name":"\"macOS\"","type":"Mac","carrier":"Verizon Fios","user_agent":"PostmanRuntime/7.43.0"},"location":{"country":{"iso_code":"US","name":"United States"},"subdivision_1":{"iso_code":"NY","name":"New York"},"subdivision_2":{"iso_code":"","name":""},"city":{"geoname_id":"5133273","name":"Queens"},"continent":{"code":"NA","name":"North America"},"latitude":40.726,"longitude":-73.848,"postal_code":"11375","timezone":"America/New_York"},"project":{"id":3868,"name":"🛜 NFC Shipment: 1/24/2025 (200,000ct)","data":{}}},
      expired: {"errors":[{"code":"40000","subcode":"1060004","type":"BadRequest","scope":"<class 'events.models.event.Event'>","message":"Event Token has expired.","details":"The provided Event Token has expired.","key":null}]},
      invalid: {"valid":false} 
    }

    let is_Valid = res.interaction?.touchpoint?.verification?.result;
    if (!is_Valid) {
      console.error(`Invalid bb_event Token: ${bb_event}`);
      RedirectInvalidPage();
      return;
    }
    else {
      console.log(`%c Valid bb_event Token: ${bb_event}`, 'background-color: green');
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    ValidateBlueBite();
  });
})();